import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faBank, faBook, faCartShopping, faFileInvoice, faHome, faRightFromBracket, faTruckArrowRight, faUser } from '@fortawesome/free-solid-svg-icons'
import { ActionCreators } from 'store/actionCreators';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';


export const BottomBar = () => {
    const dispatch = useDispatch();

    const confirmLogout = async () => {
        const result = await Swal.fire({
            title: 'Confirm logout',
            text: 'Are you sure you want to logout?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Logout',
            cancelButtonText: 'Cancel',
            focusCancel: true,
        });

        if (result.isConfirmed) {
            dispatch(ActionCreators.logout());
        }
    };

    return (
        <>
            <nav className="navbar fixed-bottom navbar-light bg-light app-bottom-bar">
                <li className="nav-item" title="Home">
                    <NavLink to="/">
                        <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                </li>
                <li className="nav-item" title="Business Summary">
                    <NavLink to="/bankAccounts">
                        <FontAwesomeIcon icon={faBook} />
                    </NavLink>
                </li>
                <li className="nav-item" title="Invoices">
                    <NavLink to="/paymentRequest">
                        <FontAwesomeIcon icon={faFileInvoice} />
                    </NavLink>
                </li>
                <li className="nav-item" title="Logout">
                    <a onClick={confirmLogout} href="#">
                        <FontAwesomeIcon icon={faRightFromBracket} />
                    </a>
                </li>
            </nav>
        </>
    )
};
